// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes borderColor {
  0% {
    border-color: #0a414e;
  }
  25% {
    border-color: #280550;
  }
  50% {
    border-color: #4d063d;
  }
  75% {
    border-color: #1a0b5c;
  }
  100% {
    border-color: #0a414e;
  }
}

@keyframes selectedUI {
  0% {
    background-position: 0% 74%;
  }
  50% {
    background-position: 100% 27%;
  }
  100% {
    background-position: 0% 74%;
  }
}

.fm-synth-ui {
  display: flex;
  flex-direction: column;
  background-color: #232323;
  color: white;
  width: 520px;
  min-width: 520px;
  overflow-y: auto;

  h2 {
    margin: 10px 0 -3px 0;
    text-align: center;
    font-family: Hack, 'Input Mono', Menlo, Monaco, Consolas, 'Courier New', monospace;
    font-weight: normal;
    font-size: 18px;
  }

  .hovered-modulation-entity {
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    color: #ddd;
    min-height: 22px;
  }

  .operator-square,
  .operator-select {
    border: 1px solid;
    animation: borderColor 15s infinite linear;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .modulation-matrix {
    display: flex;
    flex-direction: column;
    width: 490px;
    margin-left: auto;
    margin-right: auto;

    * {
      user-select: none;
    }

    .operator-row {
      display: flex;
      flex-direction: row;
      justify-content: center;

      > div {
        flex-basis: 42px;
        height: 42px;
        display: flex;
        font-size: 14px;
        justify-content: center;
      }

      .operator-select {
        cursor: pointer;
        background-color: var(--highlight-2);
        position: relative;
      }
      .operator-select[data-hovered='true'] {
        background-color: #a1b95d;
      }
      .operator-select.operator-selected {
        background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);
        background-size: 140% 140%;
        animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;
      }
      .operator-select.operator-selected[data-hovered='true'] {
        background: #f17408;
      }

      .operator-square {
        align-items: center;
        cursor: pointer;
        background-color: #121212;
      }
      .operator-square[data-active='true'] {
        background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);
        background-size: 140% 140%;
        animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;
      }
      .operator-square.operator-square-feedback {
        background-color: #340000;
      }

      .output-weight {
        background-color: #121212;
      }
      .output-weight[data-selected='true'] {
        background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);
        background-size: 140% 140%;
        animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;
      }
      .operator-weight-lens {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .adsr-param {
        font-size: 12px;
        text-align: center;
        line-height: 1;
      }
    }
  }

  .effect-dot {
    border-radius: 100%;
    width: 4px;
    height: 4px;
    position: absolute;
    bottom: 0.5px;
    border: 1px solid #ccc;
  }

  .bottom-button-wrapper {
    width: 440px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;

    .main-effect-chain-selector {
      background-color: var(--highlight-5);
      text-align: center;
      cursor: pointer;
      padding: 3px;
      margin: 2px 0px;
      border: 1px solid #181818;
      flex: 1;
      user-select: none;
      position: relative
    }
    .main-effect-chain-selector[data-active='true'] {
      background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);
      background-size: 140% 140%;
      animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;
    }
    .main-effect-chain-selector:hover {
      font-weight: bold;
    }

    .oscilloscope-button {
      flex: 0;
      margin-left: 4px;
      padding-top: 2px;
      background-color: var(--highlight-5);
      border: 1px solid #181818;
      padding: 0px 0px 2px 0px;
      max-height: 24px;
      margin-top: 2px;
      cursor: pointer;

      path {
        fill: #fcfcfc;
      }
    }

    .oscilloscope-button[data-active='true'] {
      background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);
      background-size: 140% 140%;
      animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;
    }
  }
}

#fm-synth-oscilloscope {
  width: 490px;
  height: 240px;
}

.fm-synth-configuration {
  background-color: #232323;
  padding: 0px 2px;
  height: 100%;
  min-width: 500px;
}

.operator-config {
  display: flex;
  flex-direction: column;
  max-height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 20px;
}

.configure-modulation-index {
  display: flex;
  flex-direction: column;
  width: 500px;
}

.configure-output-weight {
  width: 500px;
}

.configure-effects {
  width: 500px;

  .effects-controls {
    display: flex;
    flex-direction: column;

    .configure-effect {
      border-bottom: 1px solid #494949;

      .effect-management {
        display: flex;
        flex-direction: row;
        text-transform: uppercase;
        font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;
        opacity: 0.95;
        align-items: center;

        .bypass-checkbox {
          margin-left: 16px;
          filter: invert(1);
          cursor: pointer;
        }

        .button-placeholder {
          width: 20px;
        }

        button {
          width: 20px;
          padding: 0;
        }
        button:hover {
          font-weight: bold;
        }

        button.toggle-collapsed {
          height: 20px;
          padding-left: 2px;
          width: 24px;
          margin-right: 3px;
        }

        .effect-title {
          width: 500px;
          text-align: center;
          margin-left: -55px;
          margin-right: 28px;
          font-size: 14px;
          padding-top: 4px;
        }
      }
    }
  }

  .configure-effect:nth-child(even) {
    background-color: #000;
  }
}
`, "",{"version":3,"sources":["webpack://./src/fmSynth/FMSynth.css"],"names":[],"mappings":"AAAA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;;EAEhB;IACE,qBAAqB;IACrB,kBAAkB;IAClB,kFAAkF;IAClF,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;;MAEvB;QACE,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,eAAe;QACf,uBAAuB;MACzB;;MAEA;QACE,eAAe;QACf,oCAAoC;QACpC,kBAAkB;MACpB;MACA;QACE,yBAAyB;MAC3B;MACA;QACE,uEAAuE;QACvE,0BAA0B;QAC1B,uEAAuE;MACzE;MACA;QACE,mBAAmB;MACrB;;MAEA;QACE,mBAAmB;QACnB,eAAe;QACf,yBAAyB;MAC3B;MACA;QACE,uEAAuE;QACvE,0BAA0B;QAC1B,uEAAuE;MACzE;MACA;QACE,yBAAyB;MAC3B;;MAEA;QACE,yBAAyB;MAC3B;MACA;QACE,uEAAuE;QACvE,0BAA0B;QAC1B,uEAAuE;MACzE;MACA;QACE,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;MACrB;;MAEA;QACE,eAAe;QACf,kBAAkB;QAClB,cAAc;MAChB;IACF;EACF;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;;IAEnB;MACE,oCAAoC;MACpC,kBAAkB;MAClB,eAAe;MACf,YAAY;MACZ,eAAe;MACf,yBAAyB;MACzB,OAAO;MACP,iBAAiB;MACjB;IACF;IACA;MACE,uEAAuE;MACvE,0BAA0B;MAC1B,uEAAuE;IACzE;IACA;MACE,iBAAiB;IACnB;;IAEA;MACE,OAAO;MACP,gBAAgB;MAChB,gBAAgB;MAChB,oCAAoC;MACpC,yBAAyB;MACzB,wBAAwB;MACxB,gBAAgB;MAChB,eAAe;MACf,eAAe;;MAEf;QACE,aAAa;MACf;IACF;;IAEA;MACE,uEAAuE;MACvE,0BAA0B;MAC1B,uEAAuE;IACzE;EACF;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;;EAEZ;IACE,aAAa;IACb,sBAAsB;;IAEtB;MACE,gCAAgC;;MAEhC;QACE,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,oEAAoE;QACpE,aAAa;QACb,mBAAmB;;QAEnB;UACE,iBAAiB;UACjB,iBAAiB;UACjB,eAAe;QACjB;;QAEA;UACE,WAAW;QACb;;QAEA;UACE,WAAW;UACX,UAAU;QACZ;QACA;UACE,iBAAiB;QACnB;;QAEA;UACE,YAAY;UACZ,iBAAiB;UACjB,WAAW;UACX,iBAAiB;QACnB;;QAEA;UACE,YAAY;UACZ,kBAAkB;UAClB,kBAAkB;UAClB,kBAAkB;UAClB,eAAe;UACf,gBAAgB;QAClB;MACF;IACF;EACF;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@keyframes borderColor {\n  0% {\n    border-color: #0a414e;\n  }\n  25% {\n    border-color: #280550;\n  }\n  50% {\n    border-color: #4d063d;\n  }\n  75% {\n    border-color: #1a0b5c;\n  }\n  100% {\n    border-color: #0a414e;\n  }\n}\n\n@keyframes selectedUI {\n  0% {\n    background-position: 0% 74%;\n  }\n  50% {\n    background-position: 100% 27%;\n  }\n  100% {\n    background-position: 0% 74%;\n  }\n}\n\n.fm-synth-ui {\n  display: flex;\n  flex-direction: column;\n  background-color: #232323;\n  color: white;\n  width: 520px;\n  min-width: 520px;\n  overflow-y: auto;\n\n  h2 {\n    margin: 10px 0 -3px 0;\n    text-align: center;\n    font-family: Hack, 'Input Mono', Menlo, Monaco, Consolas, 'Courier New', monospace;\n    font-weight: normal;\n    font-size: 18px;\n  }\n\n  .hovered-modulation-entity {\n    width: 100%;\n    text-align: center;\n    text-transform: uppercase;\n    color: #ddd;\n    min-height: 22px;\n  }\n\n  .operator-square,\n  .operator-select {\n    border: 1px solid;\n    animation: borderColor 15s infinite linear;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n\n  .modulation-matrix {\n    display: flex;\n    flex-direction: column;\n    width: 490px;\n    margin-left: auto;\n    margin-right: auto;\n\n    * {\n      user-select: none;\n    }\n\n    .operator-row {\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n\n      > div {\n        flex-basis: 42px;\n        height: 42px;\n        display: flex;\n        font-size: 14px;\n        justify-content: center;\n      }\n\n      .operator-select {\n        cursor: pointer;\n        background-color: var(--highlight-2);\n        position: relative;\n      }\n      .operator-select[data-hovered='true'] {\n        background-color: #a1b95d;\n      }\n      .operator-select.operator-selected {\n        background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);\n        background-size: 140% 140%;\n        animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;\n      }\n      .operator-select.operator-selected[data-hovered='true'] {\n        background: #f17408;\n      }\n\n      .operator-square {\n        align-items: center;\n        cursor: pointer;\n        background-color: #121212;\n      }\n      .operator-square[data-active='true'] {\n        background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);\n        background-size: 140% 140%;\n        animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;\n      }\n      .operator-square.operator-square-feedback {\n        background-color: #340000;\n      }\n\n      .output-weight {\n        background-color: #121212;\n      }\n      .output-weight[data-selected='true'] {\n        background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);\n        background-size: 140% 140%;\n        animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;\n      }\n      .operator-weight-lens {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      .adsr-param {\n        font-size: 12px;\n        text-align: center;\n        line-height: 1;\n      }\n    }\n  }\n\n  .effect-dot {\n    border-radius: 100%;\n    width: 4px;\n    height: 4px;\n    position: absolute;\n    bottom: 0.5px;\n    border: 1px solid #ccc;\n  }\n\n  .bottom-button-wrapper {\n    width: 440px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    flex-direction: row;\n\n    .main-effect-chain-selector {\n      background-color: var(--highlight-5);\n      text-align: center;\n      cursor: pointer;\n      padding: 3px;\n      margin: 2px 0px;\n      border: 1px solid #181818;\n      flex: 1;\n      user-select: none;\n      position: relative\n    }\n    .main-effect-chain-selector[data-active='true'] {\n      background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);\n      background-size: 140% 140%;\n      animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;\n    }\n    .main-effect-chain-selector:hover {\n      font-weight: bold;\n    }\n\n    .oscilloscope-button {\n      flex: 0;\n      margin-left: 4px;\n      padding-top: 2px;\n      background-color: var(--highlight-5);\n      border: 1px solid #181818;\n      padding: 0px 0px 2px 0px;\n      max-height: 24px;\n      margin-top: 2px;\n      cursor: pointer;\n\n      path {\n        fill: #fcfcfc;\n      }\n    }\n\n    .oscilloscope-button[data-active='true'] {\n      background: linear-gradient(300deg, #ce463f, #e8180e, #c60346, #bf0bb8);\n      background-size: 140% 140%;\n      animation: borderColor 15s infinite linear, selectedUI 8s ease infinite;\n    }\n  }\n}\n\n#fm-synth-oscilloscope {\n  width: 490px;\n  height: 240px;\n}\n\n.fm-synth-configuration {\n  background-color: #232323;\n  padding: 0px 2px;\n  height: 100%;\n  min-width: 500px;\n}\n\n.operator-config {\n  display: flex;\n  flex-direction: column;\n  max-height: 75vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-bottom: 20px;\n}\n\n.configure-modulation-index {\n  display: flex;\n  flex-direction: column;\n  width: 500px;\n}\n\n.configure-output-weight {\n  width: 500px;\n}\n\n.configure-effects {\n  width: 500px;\n\n  .effects-controls {\n    display: flex;\n    flex-direction: column;\n\n    .configure-effect {\n      border-bottom: 1px solid #494949;\n\n      .effect-management {\n        display: flex;\n        flex-direction: row;\n        text-transform: uppercase;\n        font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;\n        opacity: 0.95;\n        align-items: center;\n\n        .bypass-checkbox {\n          margin-left: 16px;\n          filter: invert(1);\n          cursor: pointer;\n        }\n\n        .button-placeholder {\n          width: 20px;\n        }\n\n        button {\n          width: 20px;\n          padding: 0;\n        }\n        button:hover {\n          font-weight: bold;\n        }\n\n        button.toggle-collapsed {\n          height: 20px;\n          padding-left: 2px;\n          width: 24px;\n          margin-right: 3px;\n        }\n\n        .effect-title {\n          width: 500px;\n          text-align: center;\n          margin-left: -55px;\n          margin-right: 28px;\n          font-size: 14px;\n          padding-top: 4px;\n        }\n      }\n    }\n  }\n\n  .configure-effect:nth-child(even) {\n    background-color: #000;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
